const pallete = [
    {
        "name": "YEAR",
        "description": "YEAR",
        "options": [
            {
                "id": "15",
                "parentcode": "1",
                "name": "1967",
                "price": "1967",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100 Black.jpg"
            }
        ]
    },
    {
        "name": "MODEL",
        "description": "MODEL",
        "options": [
            {
                "id": "2",
                "parentcode": "2",
                "name": "CHEVELLE",
                "price": "CHEVEL",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100 Black.jpg"
            },
            {
                "id": "3",
                "parentcode": "2",
                "name": "MALIBU",
                "price": "MALIBU",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100 Black.jpg"
            },
            {
                "id": "4",
                "parentcode": "2",
                "name": "EL CAMINO",
                "price": "EL CAM",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100 Black.jpg"
            }
        ]
    },
    {
        "name": "PRODUCT_CLASS",
        "description": "PRODUCT CLASS",
        "options": [
            {
                "id": "1",
                "parentcode": "10",
                "name": "UPHOLSTERY",
                "price": "UPHOLS",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100 Black.jpg"
            }
        ]
    },
    {
        "name": "VINYL_COLORS",
        "description": "VINYL COLORS",
        "options": [
            {
                "id": "1",
                "parentcode": "11",
                "name": "BLACK (AMC/CHRYSLER 100/100A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100A Black.jpg"
            },
            {
                "id": "2",
                "parentcode": "11",
                "name": "BLACK (GM 100G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100A Black.jpg"
            },
            {
                "id": "3",
                "parentcode": "11",
                "name": "SILVER (102/102A/102G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/102 Silver.jpg"
            },
            {
                "id": "4",
                "parentcode": "11",
                "name": "SILVER (104)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/104 Silver.jpg"
            },
            {
                "id": "6",
                "parentcode": "11",
                "name": "PEWTER (130)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/130 Pewter.jpg"
            },
            {
                "id": "7",
                "parentcode": "11",
                "name": "PEWTER (138G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/138G Pewter.jpg"
            },
            {
                "id": "8",
                "parentcode": "11",
                "name": "DARK GRAY (110)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/110 Dark Gray.jpg"
            },
            {
                "id": "10",
                "parentcode": "11",
                "name": "DARK CHARCOAL (110A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/110A Charcoal.jpg"
            },
            {
                "id": "11",
                "parentcode": "11",
                "name": "CHARCOAL METALLIC (154)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/154 Charcoal.jpg"
            },
            {
                "id": "12",
                "parentcode": "11",
                "name": "GUNMETAL (140)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/140 Gunmetal.jpg"
            },
            {
                "id": "13",
                "parentcode": "11",
                "name": "FROST WHITE (220G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/220G Frost White.jpg"
            },
            {
                "id": "14",
                "parentcode": "11",
                "name": "PEARL WHITE (202)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/202 Pearl White.jpg"
            },
            {
                "id": "15",
                "parentcode": "11",
                "name": "PEARL WHITE (202G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/202G Pearl White.jpg"
            },
            {
                "id": "16",
                "parentcode": "11",
                "name": "WHITE (200)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/200 White.jpg"
            },
            {
                "id": "17",
                "parentcode": "11",
                "name": "WHITE (206G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/206G Dark White.jpg"
            },
            {
                "id": "18",
                "parentcode": "11",
                "name": "WHITE (209G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/209G White.jpg"
            },
            {
                "id": "19",
                "parentcode": "11",
                "name": "WHITE (210G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/210G White.jpg"
            },
            {
                "id": "20",
                "parentcode": "11",
                "name": "WHITE (230G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/230G White.jpg"
            },
            {
                "id": "21",
                "parentcode": "11",
                "name": "DARK WHITE (204)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/204 Dark White.jpg"
            },
            {
                "id": "22",
                "parentcode": "11",
                "name": "DARK WHITE (205A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/205A Dark White.jpg"
            },
            {
                "id": "23",
                "parentcode": "11",
                "name": "PARCHMENT METALLIC (204G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/204G Metallic Parchment.jpg"
            },
            {
                "id": "24",
                "parentcode": "11",
                "name": "PARCHMENT METALLIC (239G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/239G Metallic Parchment.jpg"
            },
            {
                "id": "25",
                "parentcode": "11",
                "name": "PARCHMENT (235G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/235G Parchment.jpg"
            },
            {
                "id": "26",
                "parentcode": "11",
                "name": "PARCHMENT (240G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/240G Metallic Parchment.jpg"
            },
            {
                "id": "27",
                "parentcode": "11",
                "name": "PARCHMENT (250/250A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/250 Parchment.jpg"
            },
            {
                "id": "28",
                "parentcode": "11",
                "name": "OPAL (210)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/210 Opal.jpg"
            },
            {
                "id": "29",
                "parentcode": "11",
                "name": "OYSTER (200G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/200G Oyster.jpg"
            },
            {
                "id": "30",
                "parentcode": "11",
                "name": "OYSTER (220)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/220 Oyster.jpg"
            },
            {
                "id": "31",
                "parentcode": "11",
                "name": "BEIGE (270A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/270A Beige.jpg"
            },
            {
                "id": "32",
                "parentcode": "11",
                "name": "BEIGE (687)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/687 Beige.jpg"
            },
            {
                "id": "33",
                "parentcode": "11",
                "name": "LIGHT BLUE (304)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/304 Light Blue.jpg"
            },
            {
                "id": "34",
                "parentcode": "11",
                "name": "LIGHT BLUE (319G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/319G Light Blue.jpg"
            },
            {
                "id": "35",
                "parentcode": "11",
                "name": "MEDIUM BLUE (302)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/302 Medium Blue.jpg"
            },
            {
                "id": "36",
                "parentcode": "11",
                "name": "BLUE (321G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/321G Blue.jpg"
            },
            {
                "id": "37",
                "parentcode": "11",
                "name": "BLUE (331A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/331A Blue.jpg"
            },
            {
                "id": "39",
                "parentcode": "11",
                "name": "BLUE (344A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/344A Blue.jpg"
            },
            {
                "id": "40",
                "parentcode": "11",
                "name": "BLUE (380G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/380G Blue.jpg"
            },
            {
                "id": "41",
                "parentcode": "11",
                "name": "DARK BLUE (336/366G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/366G Dark Blue.jpg"
            },
            {
                "id": "42",
                "parentcode": "11",
                "name": "DARK BLUE (333)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/333 Dark Blue.jpg"
            },
            {
                "id": "43",
                "parentcode": "11",
                "name": "DARK BLUE (342)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/342 Dark Blue.jpg"
            },
            {
                "id": "44",
                "parentcode": "11",
                "name": "TEAL BLUE (333G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/333G Teal Blue.jpg"
            },
            {
                "id": "45",
                "parentcode": "11",
                "name": "LAGOON BLUE (360)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/360 Lagoon Blue.jpg"
            },
            {
                "id": "46",
                "parentcode": "11",
                "name": "BRIGHT BLUE (338/337G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/337G Bright Blue.jpg"
            },
            {
                "id": "47",
                "parentcode": "11",
                "name": "BRIGHT BLUE (338G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/338G Bright Blue.jpg"
            },
            {
                "id": "48",
                "parentcode": "11",
                "name": "BRIGHT BLUE (340)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/340 Bright Blue.jpg"
            },
            {
                "id": "49",
                "parentcode": "11",
                "name": "BRIGHT BLUE METALLIC (341)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/341 Bright Blue.jpg"
            },
            {
                "id": "50",
                "parentcode": "11",
                "name": "LIGHT BLUE METALLIC (314)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/314 Light Blue Metallic.jpg"
            },
            {
                "id": "51",
                "parentcode": "11",
                "name": "LIGHT BLUE METALLIC (318)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/318 Light Blue Metallic.jpg"
            },
            {
                "id": "52",
                "parentcode": "11",
                "name": "LIGHT BLUE METALLIC (332/332G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/332 Light Blue Metallic.jpg"
            },
            {
                "id": "53",
                "parentcode": "11",
                "name": "BLUE METALLIC (310A/310G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/310A Metallic Blue.jpg"
            },
            {
                "id": "54",
                "parentcode": "11",
                "name": "BLUE METALLIC (325G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/325G Metallic Blue.jpg"
            },
            {
                "id": "55",
                "parentcode": "11",
                "name": "BLUE METALLIC (331G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/331G Metallic Blue.jpg"
            },
            {
                "id": "56",
                "parentcode": "11",
                "name": "DARK BLUE METALLIC (308)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/308 Dark Metallic Blue.jpg"
            },
            {
                "id": "57",
                "parentcode": "11",
                "name": "DARK BLUE METALLIC (330)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/330 Dark Blue Metallic.jpg"
            },
            {
                "id": "58",
                "parentcode": "11",
                "name": "DARK BLUE METALLIC (334G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/334G Dark Metallic Blue.jpg"
            },
            {
                "id": "59",
                "parentcode": "11",
                "name": "DARK BLUE METALLIC (342G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/342G Dark Metallic Blue.jpg"
            },
            {
                "id": "60",
                "parentcode": "11",
                "name": "DARK BLUE METALLIC (322/343G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/322 Medium Blue Metallic.jpg"
            },
            {
                "id": "61",
                "parentcode": "11",
                "name": "DARK BLUE METALLIC (369G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/369G Dark Metallic Blue.jpg"
            },
            {
                "id": "62",
                "parentcode": "11",
                "name": "NAVY METALLIC (320)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/320 Navy Metallic.jpg"
            },
            {
                "id": "63",
                "parentcode": "11",
                "name": "CITRON GREEN/GOLD (420)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/420 Citron.jpg"
            },
            {
                "id": "64",
                "parentcode": "11",
                "name": "LIGHT GREEN (432/432A/432G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/432 Light Metallic Green.jpg"
            },
            {
                "id": "65",
                "parentcode": "11",
                "name": "LIGHT GREEN (446)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/446 Light Green.jpg"
            },
            {
                "id": "66",
                "parentcode": "11",
                "name": "GREEN (440G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/440G Green.jpg"
            },
            {
                "id": "67",
                "parentcode": "11",
                "name": "GREEN (453A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/453A Green.jpg"
            },
            {
                "id": "68",
                "parentcode": "11",
                "name": "GREEN (463A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/463A Green.jpg"
            },
            {
                "id": "69",
                "parentcode": "11",
                "name": "DARK GREEN (418)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/418 Dark Green.jpg"
            },
            {
                "id": "70",
                "parentcode": "11",
                "name": "DARK GREEN (444)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/444-Dark_Green.jpg?v=1743162935"
            },
                      {
                "id": "70",
                "parentcode": "11",
                "name": "DARK GREEN (465G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/465G-Dark_Green.jpg?v=1743162949"
            },
            {
                "id": "71",
                "parentcode": "11",
                "name": "JADE GREEN (415G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/415G Jade Green.jpg"
            },
            {
                "id": "72",
                "parentcode": "11",
                "name": "JADE GREEN (450)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/450 Jade Green.jpg"
            },
            {
                "id": "73",
                "parentcode": "11",
                "name": "GREEN METALLIC (460G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/460G Dark Metallic Green.jpg"
            },
            {
                "id": "74",
                "parentcode": "11",
                "name": "DARK GREEN METALLIC (430)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/430 Dark Green Metallic.jpg"
            },
            {
                "id": "75",
                "parentcode": "11",
                "name": "DARK GREEN METALLIC (434)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/434 Dark Green Metallic.jpg"
            },
            {
                "id": "76",
                "parentcode": "11",
                "name": "DARK GREEN METALLIC (452)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/452 Dark Green Metallic.jpg"
            },
            {
                "id": "77",
                "parentcode": "11",
                "name": "DARK GREEN METALLIC (469G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/469G Dark Metallic Green.jpg"
            },
            {
                "id": "78",
                "parentcode": "11",
                "name": "LIGHT TURQUOISE (406)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/406 Light Turquoise.jpg"
            },
            {
                "id": "79",
                "parentcode": "11",
                "name": "GREEN (468G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/468G_Green.jpg?v=1743161227"
            },
            {
                "id": "80",
                "parentcode": "11",
                "name": "TURQUOISE METALLIC (416)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/416 Medium Turquoise Metallic.jpg"
            },
            {
                "id": "81",
                "parentcode": "11",
                "name": "TURQUOISE METALLIC (424G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/424G Light Metallic Turquoise.jpg"
            },
            {
                "id": "82",
                "parentcode": "11",
                "name": "TURQUOISE METALLIC (429G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/429G Metallic Turquoise.jpg"
            },
            {
                "id": "83",
                "parentcode": "11",
                "name": "DARK TURQUOISE METALLIC (414)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/414 Dark Turquoise Metallic.jpg"
            },
            {
                "id": "84",
                "parentcode": "11",
                "name": "DARK TURQUOISE METALLIC (448G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/448G Dark Metallic Turquoise.jpg"
            },
            {
                "id": "85",
                "parentcode": "11",
                "name": "DARK AQUA METALLIC (421G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/421G Dark Metallic Aqua.jpg"
            },
            {
                "id": "86",
                "parentcode": "11",
                "name": "RED CRIMSON (510)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/510 Red Crimson.jpg"
            },
            {
                "id": "87",
                "parentcode": "11",
                "name": "RED (501G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/501G Red.jpg"
            },
            {
                "id": "88",
                "parentcode": "11",
                "name": "RED (503A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/503A Red.jpg"
            },
            {
                "id": "89",
                "parentcode": "11",
                "name": "RED (505)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/505 Red.jpg"
            },
            {
                "id": "90",
                "parentcode": "11",
                "name": "RED (507)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/507 Red.jpg"
            },
            {
                "id": "91",
                "parentcode": "11",
                "name": "RED (548/508G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/508G Red.jpg"
            },
            {
                "id": "92",
                "parentcode": "11",
                "name": "RED (511G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/511G Red.jpg"
            },
            {
                "id": "93",
                "parentcode": "11",
                "name": "RED (513G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/513G Red.jpg"
            },
            {
                "id": "94",
                "parentcode": "11",
                "name": "RED (514G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/514G Red.jpg"
            },
            {
                "id": "95",
                "parentcode": "11",
                "name": "RED (528/528G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/528 Red.jpg"
            },
            {
                "id": "96",
                "parentcode": "11",
                "name": "RED (535G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/535G Red.jpg"
            },
            {
                "id": "97",
                "parentcode": "11",
                "name": "RED (550)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/550 Red.jpg"
            },
            {
                "id": "98",
                "parentcode": "11",
                "name": "DARK RED (502G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/502G Dark Red.jpg"
            },
            {
                "id": "99",
                "parentcode": "11",
                "name": "DARK RED (503G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/503G Dark Red.jpg"
            },
            {
                "id": "100",
                "parentcode": "11",
                "name": "DARK RED (504)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/504 Dark Red.jpg"
            },
            {
                "id": "101",
                "parentcode": "11",
                "name": "DARK RED (508)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/508 Dark Red.jpg"
            },
            {
                "id": "102",
                "parentcode": "11",
                "name": "DARK RED (512A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/512A Dark Red.jpg"
            },
            {
                "id": "103",
                "parentcode": "11",
                "name": "DARK RED (535A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/535A Dark Red.jpg"
            },
            {
                "id": "104",
                "parentcode": "11",
                "name": "RED METALLIC (520)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/520 Red Metallic.jpg"
            },
            {
                "id": "105",
                "parentcode": "11",
                "name": "RED METALLIC (520G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/520G Metallic Red.jpg"
            },
            {
                "id": "106",
                "parentcode": "11",
                "name": "BRIGHT RED (510G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/510G Bright Red.jpg"
            },
            {
                "id": "107",
                "parentcode": "11",
                "name": "CARMINE RED (504G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/504G Carmine.jpg"
            },
            {
                "id": "108",
                "parentcode": "11",
                "name": "MAROON METALLIC (526)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/526 Maroon Metallic.jpg"
            },
            {
                "id": "109",
                "parentcode": "11",
                "name": "BURGUNDY (525G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/525G Burgundy.jpg"
            },
            {
                "id": "110",
                "parentcode": "11",
                "name": "BRONZE METALLIC (640)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/640 Bronze.jpg"
            },
            {
                "id": "111",
                "parentcode": "11",
                "name": "DK BRONZE METALLIC (634/631G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/631G Bronze Gold.jpg"
            },
            {
                "id": "112",
                "parentcode": "11",
                "name": "SADDLE METALLIC (654/625G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/625G Saddle Bronze.jpg"
            },
            {
                "id": "113",
                "parentcode": "11",
                "name": "BURNISHED SADDLE (658G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/658G Burnished Saddle.jpg"
            },
            {
                "id": "114",
                "parentcode": "11",
                "name": "SADDLE (640A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/640A Saddle.jpg"
            },
            {
                "id": "115",
                "parentcode": "11",
                "name": "SADDLE (650)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/650 Saddle.jpg"
            },
            {
                "id": "116",
                "parentcode": "11",
                "name": "SADDLE (672G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/672G Saddle.jpg"
            },
            {
                "id": "117",
                "parentcode": "11",
                "name": "SADDLE (678G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/678G Saddle.jpg"
            },
            {
                "id": "118",
                "parentcode": "11",
                "name": "SADDLE (679G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/679G Saddle.jpg"
            },
            {
                "id": "119",
                "parentcode": "11",
                "name": "SADDLE (683G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/683G Saddle.jpg"
            },
            {
                "id": "120",
                "parentcode": "11",
                "name": "SADDLE (685G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/685G Saddle.jpg"
            },
            {
                "id": "121",
                "parentcode": "11",
                "name": "SADDLE (687G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/687G Saddle.jpg"
            },
            {
                "id": "122",
                "parentcode": "11",
                "name": "SADDLE (690G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/690G Saddle.jpg"
            },
            {
                "id": "123",
                "parentcode": "11",
                "name": "GOLD (660)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/660_Gold_Metallic.jpg?v=1743094584"
            },
            {
                "id": "124",
                "parentcode": "11",
                "name": "BROWN (656/656A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/656 Brown.jpg"
            },
            {
                "id": "125",
                "parentcode": "11",
                "name": "BROWN (656G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/656G Brown.jpg"
            },
            {
                "id": "126",
                "parentcode": "11",
                "name": "BROWN (662)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/662 Brown.jpg"
            },
            {
                "id": "127",
                "parentcode": "11",
                "name": "BROWN (664)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/664 Brown.jpg"
            },
            {
                "id": "128",
                "parentcode": "11",
                "name": "CHESTNUT (600)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/600 Chestnut.jpg"
            },
            {
                "id": "129",
                "parentcode": "11",
                "name": "GINGER (616)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/616 Ginger.jpg"
            },
            {
                "id": "130",
                "parentcode": "11",
                "name": "BUCKSKIN (684G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/684G Buckskin.jpg"
            },
            {
                "id": "131",
                "parentcode": "11",
                "name": "BUCKSKIN (709G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/709G Buckskin.jpg"
            },
            {
                "id": "132",
                "parentcode": "11",
                "name": "BUCKSKIN (710G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/710G Buckskin.jpg"
            },
            {
                "id": "133",
                "parentcode": "11",
                "name": "TAUPE (206)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/206 Taupe.jpg"
            },
            {
                "id": "134",
                "parentcode": "11",
                "name": "TAUPE (209)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/209 Taupe.jpg"
            },
            {
                "id": "135",
                "parentcode": "11",
                "name": "TAN (649)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/649 Tan.jpg"
            },
            {
                "id": "136",
                "parentcode": "11",
                "name": "TAN (668/668A)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/668 Tan.jpg"
            },
            {
                "id": "137",
                "parentcode": "11",
                "name": "TAN (670)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/670 Tan.jpg"
            },
            {
                "id": "138",
                "parentcode": "11",
                "name": "TAN (670G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/670G Tan.jpg"
            },
            {
                "id": "139",
                "parentcode": "11",
                "name": "CAMEL TAN (671G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/671G Camel Tan.jpg"
            },
            {
                "id": "140",
                "parentcode": "11",
                "name": "CAMEL TAN (688G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/688G Camel Tan.jpg"
            },
            {
                "id": "141",
                "parentcode": "11",
                "name": "SANDALWOOD (699/694G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/694G Sandalwood.jpg"
            },
            {
                "id": "140",
                "parentcode": "11",
                "name": "HONEY GOLD (672)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/672_Honey_Gold.jpg?v=1743094460"
            },
            {
                "id": "143",
                "parentcode": "11",
                "name": "SANDALWOOD (697G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/697G Sandalwood.jpg"
            },
            {
                "id": "144",
                "parentcode": "11",
                "name": "DARK SANDALWOOD (689G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/689G Dark Sandalwood.jpg"
            },
            {
                "id": "145",
                "parentcode": "11",
                "name": "GOLD (635G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/635G Gold.jpg"
            },
            {
                "id": "146",
                "parentcode": "11",
                "name": "GOLD METALLIC (642G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/642G Metallic Gold.jpg"
            },
            {
                "id": "147",
                "parentcode": "11",
                "name": "GOLD METALLIC (630/650G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/630 Gold.jpg"
            },
            {
                "id": "148",
                "parentcode": "11",
                "name": "GOLD METALLIC (651G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/651G Metallic Gold.jpg"
            },
            {
                "id": "149",
                "parentcode": "11",
                "name": "MEDIUM FAWN METALLIC (610)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/610 Metallic Fawn.jpg"
            },
            {
                "id": "150",
                "parentcode": "11",
                "name": "MEDIUM GOLD METALLIC (614)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/614 Gold.jpg"
            },
            {
                "id": "151",
                "parentcode": "11",
                "name": "EMBER GOLD (636)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/636 Ember Gold.jpg"
            },
            {
                "id": "152",
                "parentcode": "11",
                "name": "EMBER GOLD (666)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/666 Ember Gold.jpg"
            },
            {
                "id": "153",
                "parentcode": "11",
                "name": "WILLOW GOLD (645G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/645G Willow Gold.jpg"
            },
            {
                "id": "155",
                "parentcode": "11",
                "name": "COPPER METALLIC (620)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/620 Copper Metallic.jpg"
            },
            {
                "id": "156",
                "parentcode": "11",
                "name": "DARK COPPER METALLIC (606)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/606 Dark Copper.jpg"
            },
            {
                "id": "157",
                "parentcode": "11",
                "name": "PEARL YELLOW (644/640G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/640G Pearl Yellow.jpg"
            },
            {
                "id": "158",
                "parentcode": "11",
                "name": "YELLOW (641G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/641G Yellow.jpg"
            },
            {
                "id": "159",
                "parentcode": "11",
                "name": "ORANGE (500G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/500G Orange.jpg"
            },
            {
                "id": "160",
                "parentcode": "11",
                "name": "DARK ORANGE (542)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/542 Dark Orange.jpg"
            },
            {
                "id": "161",
                "parentcode": "11",
                "name": "BRIGHT ORANGE (560)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/560 Bright Orange.jpg"
            },
            {
                "id": "162",
                "parentcode": "11",
                "name": "BURNT ORANGE (540)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/540 Burnt Orange.jpg"
            },
            {
                "id": "163",
                "parentcode": "11",
                "name": "SIENNA (657G)",
                "price": "90",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/657G Sienna.jpg"
            }
        ]
    },
    {
        "name": "GRAINS",
        "description": "GRAINS",
        "options": [
            {
                "id": "1",
                "parentcode": "12",
                "name": "ASCOT",
                "price": "ASCOT",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Ascot.jpg"
            },
            {
                "id": "2",
                "parentcode": "12",
                "name": "BAMBINO",
                "price": "BAMBIN",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Bambino.jpg"
            },
            {
                "id": "3",
                "parentcode": "12",
                "name": "BASKETWEAVE (1964 CHRYSLER)",
                "price": "BASKET",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/1964 Basketweave.jpg"
            },
            {
                "id": "4",
                "parentcode": "12",
                "name": "BASKETWEAVE (1965 CHRYSLER)",
                "price": "BASKET",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Chrysler Basketweave.jpg"
            },
            {
                "id": "5",
                "parentcode": "12",
                "name": "BASKETWEAVE (AMC)",
                "price": "BASKET",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/AMC Basketweave.jpg"
            },
            {
                "id": "6",
                "parentcode": "12",
                "name": "BASKETWEAVE (GM)",
                "price": "BASKET",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Basketweave.jpg"
            },
            {
                "id": "7",
                "parentcode": "12",
                "name": "BEDFORD",
                "price": "BEDFOR",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Bedford.jpg"
            },
            {
                "id": "8",
                "parentcode": "12",
                "name": "BELMONT",
                "price": "BELMON",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Belmont.jpg"
            },
            {
                "id": "9",
                "parentcode": "12",
                "name": "BISON",
                "price": "BISON",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Bison.jpg"
            },
            {
                "id": "10",
                "parentcode": "12",
                "name": "BOAR",
                "price": "BOAR",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Boar.jpg"
            },
            {
                "id": "11",
                "parentcode": "12",
                "name": "CIRRUS",
                "price": "CIRRUS",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Cirrus.jpg"
            },
            {
                "id": "12",
                "parentcode": "12",
                "name": "COACHMAN",
                "price": "COACHM",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Coachman.jpg"
            },
            {
                "id": "13",
                "parentcode": "12",
                "name": "COLOGNE",
                "price": "COLOGN",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Cologne.jpg"
            },
            {
                "id": "14",
                "parentcode": "12",
                "name": "COMFORTWEAVE",
                "price": "WEAVE",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Comfortweave.jpg"
            },
            {
                "id": "15",
                "parentcode": "12",
                "name": "CRATER",
                "price": "CRATER",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Crater.jpg"
            },
            {
                "id": "16",
                "parentcode": "12",
                "name": "CRUSH",
                "price": "CRUSH",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Crush.jpg"
            },
            {
                "id": "17",
                "parentcode": "12",
                "name": "CRUSHED ICE",
                "price": "CRUSHE",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Crushed Ice.jpg"
            },
            {
                "id": "18",
                "parentcode": "12",
                "name": "DAKOTA",
                "price": "DAKOTA",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Dakota.jpg"
            },
            {
                "id": "19",
                "parentcode": "12",
                "name": "DERMA",
                "price": "DERMA",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Derma.jpg"
            },
            {
                "id": "20",
                "parentcode": "12",
                "name": "DIAMOND BASKETWEAVE",
                "price": "DIAMON",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Diamond Basketweave.jpg"
            },
            {
                "id": "21",
                "parentcode": "12",
                "name": "DIAMOND WAFFLE",
                "price": "DIAMON",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Diamond Waffle.jpg"
            },
            {
                "id": "22",
                "parentcode": "12",
                "name": "DOESKIN",
                "price": "DOESKI",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Doeskin.jpg"
            },
            {
                "id": "23",
                "parentcode": "12",
                "name": "DORCHESTER",
                "price": "DORCHE",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Dorchester.jpg"
            },
            {
                "id": "24",
                "parentcode": "12",
                "name": "DOUBLE DIAMOND",
                "price": "DOUBLE",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Double Diamond.jpg"
            },
            {
                "id": "25",
                "parentcode": "12",
                "name": "DOUBLE STITCH RIB",
                "price": "DOUBLE",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Double Stitch Rib.jpg"
            },
            {
                "id": "26",
                "parentcode": "12",
                "name": "EL PASO",
                "price": "EL PAS",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/El Paso.jpg"
            },
            {
                "id": "27",
                "parentcode": "12",
                "name": "ELK",
                "price": "GM ELK",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Elk.jpg"
            },
            {
                "id": "28",
                "parentcode": "12",
                "name": "EMPIRE",
                "price": "EMPIRE",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Empire.jpg"
            },
            {
                "id": "29",
                "parentcode": "12",
                "name": "KNITTED",
                "price": "KNITTE",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Knitted.jpg"
            },
            {
                "id": "30",
                "parentcode": "12",
                "name": "KRINKLE",
                "price": "KRINKL",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Krinkle.jpg"
            },
            {
                "id": "31",
                "parentcode": "12",
                "name": "KV",
                "price": "KV",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/KV.jpg"
            },
            {
                "id": "32",
                "parentcode": "12",
                "name": "LAREDO",
                "price": "LAREDO",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Laredo.jpg"
            },
            {
                "id": "33",
                "parentcode": "12",
                "name": "MADRID",
                "price": "MADRID",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Madrid.jpg"
            },
            {
                "id": "34",
                "parentcode": "12",
                "name": "OSTRICH",
                "price": "OSTRIC",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Ostrich.jpg"
            },
            {
                "id": "35",
                "parentcode": "12",
                "name": "OXEN",
                "price": "OXEN",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Oxen.jpg"
            },
            {
                "id": "36",
                "parentcode": "12",
                "name": "OXFORD",
                "price": "OXFORD",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Oxford.jpg"
            },
            {
                "id": "37",
                "parentcode": "12",
                "name": "PEMBROOK",
                "price": "PEMBRO",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Pembrook.jpg"
            },
            {
                "id": "38",
                "parentcode": "12",
                "name": "PIGSKIN",
                "price": "PIGSKI",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Pigskin.jpg"
            },
            {
                "id": "39",
                "parentcode": "12",
                "name": "PINPOINT",
                "price": "PINPOI",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Pinpoint.jpg"
            },
            {
                "id": "41",
                "parentcode": "12",
                "name": "RANGER",
                "price": "RANGER",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Ranger.jpg"
            },
            {
                "id": "43",
                "parentcode": "12",
                "name": "REED",
                "price": "REED",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Reed.jpg"
            },
            {
                "id": "44",
                "parentcode": "12",
                "name": "REGAL",
                "price": "REGAL",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Regal.jpg"
            },
            {
                "id": "45",
                "parentcode": "12",
                "name": "RICHMOND",
                "price": "RICHMO",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Richmond.jpg"
            },
            {
                "id": "46",
                "parentcode": "12",
                "name": "ROSETTE",
                "price": "ROSETT",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Rosette.jpg"
            },
            {
                "id": "47",
                "parentcode": "12",
                "name": "ROULET",
                "price": "ROULET",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Roulet.jpg"
            },
            {
                "id": "48",
                "parentcode": "12",
                "name": "SEVILLE 'A'",
                "price": "SEVILL",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Seville A.jpg"
            },
            {
                "id": "49",
                "parentcode": "12",
                "name": "SEVILLE 'B'",
                "price": "SEVILL",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Seville B.jpg"
            },
            {
                "id": "50",
                "parentcode": "12",
                "name": "SHALLOW ELK",
                "price": "SHALLO",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Shallow Elk.jpg"
            },
            {
                "id": "51",
                "parentcode": "12",
                "name": "SIERRA",
                "price": "SIERRA",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Sierra.jpg"
            },
            {
                "id": "52",
                "parentcode": "12",
                "name": "STAR",
                "price": "STAR",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Star.jpg"
            },
            {
                "id": "53",
                "parentcode": "12",
                "name": "TETRA",
                "price": "TETRA",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Tetra.jpg"
            },
            {
                "id": "54",
                "parentcode": "12",
                "name": "UGANDA",
                "price": "UGANDA",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Uganda.jpg"
            },
            {
                "id": "55",
                "parentcode": "12",
                "name": "VENTILAIR",
                "price": "VENTIL",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Ventilair.jpg"
            },
            {
                "id": "56",
                "parentcode": "12",
                "name": "VEXON",
                "price": "VEXON",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Vexon.jpg"
            },
            {
                "id": "58",
                "parentcode": "12",
                "name": "WALRUS",
                "price": "WALRUS",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Walrus.jpg"
            },
            {
                "id": "59",
                "parentcode": "12",
                "name": "1/16 RIB",
                "price": "1/16 R",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/One Sixteenth Rib.jpg"
            },
            {
                "id": "60",
                "parentcode": "12",
                "name": "1/4 RIB",
                "price": "1/4 RI",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/One Quarter Rib.jpg"
            },
            {
                "id": "61",
                "parentcode": "12",
                "name": "3/5 RIB",
                "price": "3/5 RI",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Three Fifth Rib.jpg"
            }
        ]
    },
    {
        "name": "LEATHER_COLORS",
        "description": "LEATHER COLORS",
        "options": [
            {
                "id": "1",
                "parentcode": "13",
                "name": "BLACK (100)",
                "price": "485",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100 Black.jpg"
            },
            {
                "id": "2",
                "parentcode": "13",
                "name": "GUNMETAL (140)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/140 Gunmetal.jpg"
            },
            {
                "id": "3",
                "parentcode": "13",
                "name": "CHARCOAL (154)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/154 Charcoal.jpg"
            },
            {
                "id": "4",
                "parentcode": "13",
                "name": "DARK CHARCOAL (110A)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/110A Charcoal.jpg"
            },
            {
                "id": "5",
                "parentcode": "13",
                "name": "SILVER (102G)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/102G Silver.jpg"
            },
            {
                "id": "6",
                "parentcode": "13",
                "name": "WHITE (200)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/200 White.jpg"
            },
            {
                "id": "7",
                "parentcode": "13",
                "name": "PEARL WHITE (202)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/202 Pearl White.jpg"
            },
            {
                "id": "8",
                "parentcode": "13",
                "name": "DARK BLUE (330)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/330 Dark Blue Metallic.jpg"
            },
            {
                "id": "9",
                "parentcode": "13",
                "name": "BRIGHT BLUE (338)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/338 Bright Blue.jpg"
            },
            {
                "id": "10",
                "parentcode": "13",
                "name": "DARK GREEN (434)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/434 Dark Green Metallic.jpg"
            },
            {
                "id": "11",
                "parentcode": "13",
                "name": "DARK RED (512A)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/512A Dark Red.jpg"
            },
            {
                "id": "12",
                "parentcode": "13",
                "name": "RED METALLIC (520)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/520 Red Metallic.jpg"
            },
            {
                "id": "13",
                "parentcode": "13",
                "name": "BURNT ORANGE (540)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/540 Burnt Orange.jpg"
            },
            {
                "id": "14",
                "parentcode": "13",
                "name": "SADDLE (640A)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/640A Saddle.jpg"
            },
            {
                "id": "15",
                "parentcode": "13",
                "name": "SADDLE (650)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/650 Saddle.jpg"
            },
            {
                "id": "16",
                "parentcode": "13",
                "name": "BROWN (655A)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/655A Brown.jpg"
            },
            {
                "id": "17",
                "parentcode": "13",
                "name": "BROWN (656)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/656 Brown.jpg"
            },
            {
                "id": "18",
                "parentcode": "13",
                "name": "DARK BROWN (664)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/664 Brown.jpg"
            },
            {
                "id": "19",
                "parentcode": "13",
                "name": "EMBER GOLD (666)",
                "price": "975",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/666 Ember Gold.jpg"
            }
        ]
    },
    {
        "name": "CLOTH_COLORS",
        "description": "CLOTH COLORS",
        "options": [
            {
                "id": "1",
                "parentcode": "14",
                "name": "BLACK/WHITE SALT/PEPPER (810)",
                "price": "250",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/810 Salt and Pepper Cloth Black and White.jpg"
            },
            {
                "id": "2",
                "parentcode": "14",
                "name": "BLACK/WHITE PLAID (830)",
                "price": "250",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/830 Plaid Cloth Black and White.jpg"
            },
            {
                "id": "3",
                "parentcode": "14",
                "name": "BLACK/WHITE HOUNDSTOOTH (831G)",
                "price": "250",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/831G Black and White Houndstooth Cloth.jpg"
            },
            {
                "id": "4",
                "parentcode": "14",
                "name": "BLACK/WHITE HOUNDSTOOTH (824G)",
                "price": "250",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/824G Black and White Houndstooth Cloth.jpg"
            },
            {
                "id": "5",
                "parentcode": "14",
                "name": "BLK/ORANGE HOUNDSTOOTH (825G)",
                "price": "250",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/825G Black and Orange Houndstooth Cloth.jpg"
            },
            {
                "id": "6",
                "parentcode": "14",
                "name": "BLK/YELLOW HOUNDSTOOTH (826G)",
                "price": "250",
                "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/826G Black and Yellow Houndstooth Cloth.jpg"
            }
        ]
    }
]




// const pallete = [
//     {
//         "name": "YEAR",
//         "description": "YEAR",
//         "options": [
//             {
//                 "id": "15",
//                 "parentcode": "1",
//                 "name": "1967",
//                 "price": "1967",
//                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
//             }
//         ]
//     },
//     {
//         "name": "MODEL",
//         "description": "MODEL",
//         "options": [
//             {
//                 "id": "2",
//                 "parentcode": "2",
//                 "name": "CHEVELLE",
//                 "price": "CHEVEL",
//                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
//             },
//             {
//                 "id": "3",
//                 "parentcode": "2",
//                 "name": "MALIBU",
//                 "price": "MALIBU",
//                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
//             },
//             {
//                 "id": "4",
//                 "parentcode": "2",
//                 "name": "EL CAMINO",
//                 "price": "EL CAM",
//                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
//             }
//         ]
//     },
//     {
//         "name": "PRODUCT_CLASS",
//         "description": "PRODUCT CLASS",
//         "options": [
//             {
//                 "id": "1",
//                 "parentcode": "10",
//                 "name": "UPHOLSTERY",
//                 "price": "UPHOLS",
//                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
//             }
//         ]
//     },
//     {
//         "name": "VINYL_COLORS",
//         "description": "VINYL COLORS",
//         "options": [
//             {
//                 "id": "2",
//                 "parentcode": "11",
//                 "name": "BLACK (GM 100G)",
//                 "price": "90",
//                 "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/100A_Black.jpg?v=1690458729"
//             },
//             {
//                 "id": "2",
//                 "parentcode": "11",
//                 "name": "BLACK (GM 100G)",
//                 "price": "90",
//                 "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/206G_Dark_White.jpg?v=1690458730"
//             }
//         ]
//     },
//     {
//         "name": "GRAINS",
//         "description": "GRAINS",
//         "options": [
//             {
//                 "id": "2",
//                 "parentcode": "12",
//                 "name": "BLACK (GM 100G)",
//                 "price": "90",
//                 "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Ascot.jpg?v=1690458854"
//             },
//             {
//                 "id": "2",
//                 "parentcode": "12",
//                 "name": "BLACK (GM 100G)",
//                 "price": "90",
//                 "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/Diamond_Basketweave.jpg?v=1690458854"
//             }
//         ]
//     },
//     {
//         "name": "LEATHER_COLORS",
//         "description": "LEATHER COLORS",
//         "options": [
//             {
//                 "id": "2",
//                 "parentcode": "12",
//                 "name": "BLACK (GM 100G)",
//                 "price": "90",
//                 "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/338_Bright_Blue.jpg?v=1690458776"
//             },            
//             {
//                 "id": "3",
//                 "parentcode": "12",
//                 "name": "BLACK (GM 100G)",
//                 "price": "90",
//                 "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/512A_Dark_Red.jpg?v=1690458783"
//             }
//         ]
//     },
//     {
//         "name": "CLOTH_COLORS",
//         "description": "CLOTH COLORS",
//         "options": [
//             {
//                 "id": "2",
//                 "parentcode": "12",
//                 "name": "BLACK (GM 100G)",
//                 "price": "90",
//                 "image": "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/810_Salt_and_Pepper_Cloth_Black_and_White.jpg?v=1690458818"
//             }
//         ]
//     }
// ]


// // const pallete = [
// //     {
// //         "name": "YEAR",
// //         "description": "YEAR",
// //         "options": [
// //             {
// //                 "id": "15",
// //                 "parentcode": "1",
// //                 "name": "1967",
// //                 "price": "1967",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
// //             }
// //         ]
// //     },
// //     {
// //         "name": "MODEL",
// //         "description": "MODEL",
// //         "options": [
// //             {
// //                 "id": "2",
// //                 "parentcode": "2",
// //                 "name": "CHEVELLE",
// //                 "price": "CHEVEL",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
// //             },
// //             {
// //                 "id": "3",
// //                 "parentcode": "2",
// //                 "name": "MALIBU",
// //                 "price": "MALIBU",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
// //             },
// //             {
// //                 "id": "4",
// //                 "parentcode": "2",
// //                 "name": "EL CAMINO",
// //                 "price": "EL CAM",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
// //             }
// //         ]
// //     },
// //     {
// //         "name": "PRODUCT_CLASS",
// //         "description": "PRODUCT CLASS",
// //         "options": [
// //             {
// //                 "id": "1",
// //                 "parentcode": "10",
// //                 "name": "UPHOLSTERY",
// //                 "price": "UPHOLS",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
// //             }
// //         ]
// //     },
// //     {
// //         "name": "VINYL_COLORS",
// //         "description": "VINYL COLORS",
// //         "options": [
// //             {
// //                 "id": "1",
// //                 "parentcode": "11",
// //                 "name": "BLACK (AMC/CHRYSLER 100/100A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100A Black.jpg",
// //                 "width": 27,
// //                 "height": 27,
// //                 "base64": "/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAkGBwgHBgkICAgKCgkLDhcPDg0NDhwUFREXIh4jIyEeICAlKjUtJScyKCAgLj8vMjc5PDw8JC1CRkE6RjU7PDn/2wBDAQoKCg4MDhsPDxs5JiAmOTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTn/wgARCAJYAlgDAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAACPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//EABQQAQAAAAAAAAAAAAAAAAAAAMD/2gAIAQEAAT8AL8//xAAUEQEAAAAAAAAAAAAAAAAAAADA/9oACAECAQE/AC/P/8QAFBEBAAAAAAAAAAAAAAAAAAAAwP/aAAgBAwEBPwAvz//Z"
// //             },
// //             {
// //                 "id": "2",
// //                 "parentcode": "11",
// //                 "name": "BLACK (GM 100G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100A Black.jpg"
// //             },
// //             {
// //                 "id": "3",
// //                 "parentcode": "11",
// //                 "name": "SILVER (102/102A/102G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/102 Silver.jpg"
// //             },
// //             {
// //                 "id": "4",
// //                 "parentcode": "11",
// //                 "name": "SILVER (104)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/104 Silver.jpg"
// //             },
// //             {
// //                 "id": "5",
// //                 "parentcode": "11",
// //                 "name": "PLATINUM (135G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/135G Platinum.jpg"
// //             },
// //             {
// //                 "id": "6",
// //                 "parentcode": "11",
// //                 "name": "PEWTER (130)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/130 Pewter.jpg"
// //             },
// //             {
// //                 "id": "7",
// //                 "parentcode": "11",
// //                 "name": "PEWTER (138G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/138G Pewter.jpg"
// //             },
// //             {
// //                 "id": "8",
// //                 "parentcode": "11",
// //                 "name": "DARK GRAY (110)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/110 Dark Gray.jpg"
// //             },
// //             {
// //                 "id": "9",
// //                 "parentcode": "11",
// //                 "name": "DARK GRAY (125)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/125 Dark Gray.jpg"
// //             },
// //             {
// //                 "id": "10",
// //                 "parentcode": "11",
// //                 "name": "DARK CHARCOAL (110A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/110A Charcoal.jpg"
// //             },
// //             {
// //                 "id": "11",
// //                 "parentcode": "11",
// //                 "name": "CHARCOAL METALLIC (154)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/154 Charcoal.jpg"
// //             },
// //             {
// //                 "id": "12",
// //                 "parentcode": "11",
// //                 "name": "GUNMETAL (140)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/140 Gunmetal.jpg"
// //             },
// //             {
// //                 "id": "13",
// //                 "parentcode": "11",
// //                 "name": "FROST WHITE (220G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/220G Frost White.jpg"
// //             },
// //             {
// //                 "id": "14",
// //                 "parentcode": "11",
// //                 "name": "PEARL WHITE (202)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/202 Pearl White.jpg"
// //             },
// //             {
// //                 "id": "15",
// //                 "parentcode": "11",
// //                 "name": "PEARL WHITE (202G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/202G Pearl White.jpg"
// //             },
// //             {
// //                 "id": "16",
// //                 "parentcode": "11",
// //                 "name": "WHITE (200)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/200 White.jpg"
// //             },
// //             {
// //                 "id": "17",
// //                 "parentcode": "11",
// //                 "name": "WHITE (206G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/206G Dark White.jpg"
// //             },
// //             {
// //                 "id": "18",
// //                 "parentcode": "11",
// //                 "name": "WHITE (209G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/209G White.jpg"
// //             },
// //             {
// //                 "id": "19",
// //                 "parentcode": "11",
// //                 "name": "WHITE (210G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/210G White.jpg"
// //             },
// //             {
// //                 "id": "20",
// //                 "parentcode": "11",
// //                 "name": "WHITE (230G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/230G White.jpg"
// //             },
// //             {
// //                 "id": "21",
// //                 "parentcode": "11",
// //                 "name": "DARK WHITE (204)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/204 Dark White.jpg"
// //             },
// //             {
// //                 "id": "22",
// //                 "parentcode": "11",
// //                 "name": "DARK WHITE (205A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/205A Dark White.jpg"
// //             },
// //             {
// //                 "id": "23",
// //                 "parentcode": "11",
// //                 "name": "PARCHMENT METALLIC (204G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/204G Metallic Parchment.jpg"
// //             },
// //             {
// //                 "id": "24",
// //                 "parentcode": "11",
// //                 "name": "PARCHMENT METALLIC (239G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/239G Metallic Parchment.jpg"
// //             },
// //             {
// //                 "id": "25",
// //                 "parentcode": "11",
// //                 "name": "PARCHMENT (235G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/235G Parchment.jpg"
// //             },
// //             {
// //                 "id": "26",
// //                 "parentcode": "11",
// //                 "name": "PARCHMENT (240G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/240G Metallic Parchment.jpg"
// //             },
// //             {
// //                 "id": "27",
// //                 "parentcode": "11",
// //                 "name": "PARCHMENT (250/250A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/250 Parchment.jpg"
// //             },
// //             {
// //                 "id": "28",
// //                 "parentcode": "11",
// //                 "name": "OPAL (210)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/210 Opal.jpg"
// //             },
// //             {
// //                 "id": "29",
// //                 "parentcode": "11",
// //                 "name": "OYSTER (200G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/200G Oyster.jpg"
// //             },
// //             {
// //                 "id": "30",
// //                 "parentcode": "11",
// //                 "name": "OYSTER (220)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/220 Oyster.jpg"
// //             },
// //             {
// //                 "id": "31",
// //                 "parentcode": "11",
// //                 "name": "BEIGE (270A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/270A Beige.jpg"
// //             },
// //             {
// //                 "id": "32",
// //                 "parentcode": "11",
// //                 "name": "BEIGE (687)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/687 Beige.jpg"
// //             },
// //             {
// //                 "id": "33",
// //                 "parentcode": "11",
// //                 "name": "LIGHT BLUE (304)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/304 Light Blue.jpg"
// //             },
// //             {
// //                 "id": "34",
// //                 "parentcode": "11",
// //                 "name": "LIGHT BLUE (319G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/319G Light Blue.jpg"
// //             },
// //             {
// //                 "id": "35",
// //                 "parentcode": "11",
// //                 "name": "MEDIUM BLUE (302)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/302 Medium Blue.jpg"
// //             },
// //             {
// //                 "id": "36",
// //                 "parentcode": "11",
// //                 "name": "BLUE (321G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/321G Blue.jpg"
// //             },
// //             {
// //                 "id": "37",
// //                 "parentcode": "11",
// //                 "name": "BLUE (331A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/331A Blue.jpg"
// //             },
// //             {
// //                 "id": "38",
// //                 "parentcode": "11",
// //                 "name": "BLUE (333A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/333A Blue.jpg"
// //             },
// //             {
// //                 "id": "39",
// //                 "parentcode": "11",
// //                 "name": "BLUE (344A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/344A Blue.jpg"
// //             },
// //             {
// //                 "id": "40",
// //                 "parentcode": "11",
// //                 "name": "BLUE (380G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/380G Blue.jpg"
// //             },
// //             {
// //                 "id": "41",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE (336/366G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/366G Dark Blue.jpg"
// //             },
// //             {
// //                 "id": "42",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE (333)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/333 Dark Blue.jpg"
// //             },
// //             {
// //                 "id": "43",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE (342)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/342 Dark Blue.jpg"
// //             },
// //             {
// //                 "id": "44",
// //                 "parentcode": "11",
// //                 "name": "TEAL BLUE (333G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/333G Teal Blue.jpg"
// //             },
// //             {
// //                 "id": "45",
// //                 "parentcode": "11",
// //                 "name": "LAGOON BLUE (360)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/360 Lagoon Blue.jpg"
// //             },
// //             {
// //                 "id": "46",
// //                 "parentcode": "11",
// //                 "name": "BRIGHT BLUE (338/337G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/337G Bright Blue.jpg"
// //             },
// //             {
// //                 "id": "47",
// //                 "parentcode": "11",
// //                 "name": "BRIGHT BLUE (338G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/338G Bright Blue.jpg"
// //             },
// //             {
// //                 "id": "48",
// //                 "parentcode": "11",
// //                 "name": "BRIGHT BLUE (340)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/340 Bright Blue.jpg"
// //             },
// //             {
// //                 "id": "49",
// //                 "parentcode": "11",
// //                 "name": "BRIGHT BLUE METALLIC (341)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/341 Bright Blue.jpg"
// //             },
// //             {
// //                 "id": "50",
// //                 "parentcode": "11",
// //                 "name": "LIGHT BLUE METALLIC (314)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/314 Light Blue Metallic.jpg"
// //             },
// //             {
// //                 "id": "51",
// //                 "parentcode": "11",
// //                 "name": "LIGHT BLUE METALLIC (318)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/318 Light Blue Metallic.jpg"
// //             },
// //             {
// //                 "id": "52",
// //                 "parentcode": "11",
// //                 "name": "LIGHT BLUE METALLIC (332/332G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/332 Light Blue Metallic.jpg"
// //             },
// //             {
// //                 "id": "53",
// //                 "parentcode": "11",
// //                 "name": "BLUE METALLIC (310A/310G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/310A Metallic Blue.jpg"
// //             },
// //             {
// //                 "id": "54",
// //                 "parentcode": "11",
// //                 "name": "BLUE METALLIC (325G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/325G Metallic Blue.jpg"
// //             },
// //             {
// //                 "id": "55",
// //                 "parentcode": "11",
// //                 "name": "BLUE METALLIC (331G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/331G Metallic Blue.jpg"
// //             },
// //             {
// //                 "id": "56",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE METALLIC (308)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/308 Dark Metallic Blue.jpg"
// //             },
// //             {
// //                 "id": "57",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE METALLIC (330)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/330 Dark Blue Metallic.jpg"
// //             },
// //             {
// //                 "id": "58",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE METALLIC (334G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/334G Dark Metallic Blue.jpg"
// //             },
// //             {
// //                 "id": "59",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE METALLIC (342G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/342G Dark Metallic Blue.jpg"
// //             },
// //             {
// //                 "id": "60",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE METALLIC (322/343G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/322 Medium Blue Metallic.jpg"
// //             },
// //             {
// //                 "id": "61",
// //                 "parentcode": "11",
// //                 "name": "DARK BLUE METALLIC (369G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/369G Dark Metallic Blue.jpg"
// //             },
// //             {
// //                 "id": "62",
// //                 "parentcode": "11",
// //                 "name": "NAVY METALLIC (320)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/320 Navy Metallic.jpg"
// //             },
// //             {
// //                 "id": "63",
// //                 "parentcode": "11",
// //                 "name": "CITRON GREEN/GOLD (420)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/420 Citron.jpg"
// //             },
// //             {
// //                 "id": "64",
// //                 "parentcode": "11",
// //                 "name": "LIGHT GREEN (432/432A/432G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/432 Light Metallic Green.jpg"
// //             },
// //             {
// //                 "id": "65",
// //                 "parentcode": "11",
// //                 "name": "LIGHT GREEN (446)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/446 Light Green.jpg"
// //             },
// //             {
// //                 "id": "66",
// //                 "parentcode": "11",
// //                 "name": "GREEN (440G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/440G Green.jpg"
// //             },
// //             {
// //                 "id": "67",
// //                 "parentcode": "11",
// //                 "name": "GREEN (453A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/453A Green.jpg"
// //             },
// //             {
// //                 "id": "68",
// //                 "parentcode": "11",
// //                 "name": "GREEN (463A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/463A Green.jpg"
// //             },
// //             {
// //                 "id": "69",
// //                 "parentcode": "11",
// //                 "name": "DARK GREEN (418)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/418 Dark Green.jpg"
// //             },
// //             {
// //                 "id": "70",
// //                 "parentcode": "11",
// //                 "name": "DARK GREEN (444/465G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/444 Dark Green.jpg"
// //             },
// //             {
// //                 "id": "71",
// //                 "parentcode": "11",
// //                 "name": "JADE GREEN (415G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/415G Jade Green.jpg"
// //             },
// //             {
// //                 "id": "72",
// //                 "parentcode": "11",
// //                 "name": "JADE GREEN (450)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/450 Jade Green.jpg"
// //             },
// //             {
// //                 "id": "73",
// //                 "parentcode": "11",
// //                 "name": "GREEN METALLIC (460G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/460G Dark Metallic Green.jpg"
// //             },
// //             {
// //                 "id": "74",
// //                 "parentcode": "11",
// //                 "name": "DARK GREEN METALLIC (430)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/430 Dark Green Metallic.jpg"
// //             },
// //             {
// //                 "id": "75",
// //                 "parentcode": "11",
// //                 "name": "DARK GREEN METALLIC (434)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/434 Dark Green Metallic.jpg"
// //             },
// //             {
// //                 "id": "76",
// //                 "parentcode": "11",
// //                 "name": "DARK GREEN METALLIC (452)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/452 Dark Green Metallic.jpg"
// //             },
// //             {
// //                 "id": "77",
// //                 "parentcode": "11",
// //                 "name": "DARK GREEN METALLIC (469G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/469G Dark Metallic Green.jpg"
// //             },
// //             {
// //                 "id": "78",
// //                 "parentcode": "11",
// //                 "name": "LIGHT TURQUOISE (406)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/406 Light Turquoise.jpg"
// //             },
// //             {
// //                 "id": "79",
// //                 "parentcode": "11",
// //                 "name": "LT TURQUOISE METALLIC (420G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/420G Light Metallic Turquoise.jpg"
// //             },
// //             {
// //                 "id": "80",
// //                 "parentcode": "11",
// //                 "name": "TURQUOISE METALLIC (416)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/416 Medium Turquoise Metallic.jpg"
// //             },
// //             {
// //                 "id": "81",
// //                 "parentcode": "11",
// //                 "name": "TURQUOISE METALLIC (424G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/424G Light Metallic Turquoise.jpg"
// //             },
// //             {
// //                 "id": "82",
// //                 "parentcode": "11",
// //                 "name": "TURQUOISE METALLIC (429G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/429G Metallic Turquoise.jpg"
// //             },
// //             {
// //                 "id": "83",
// //                 "parentcode": "11",
// //                 "name": "DARK TURQUOISE METALLIC (414)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/414 Dark Turquoise Metallic.jpg"
// //             },
// //             {
// //                 "id": "84",
// //                 "parentcode": "11",
// //                 "name": "DARK TURQUOISE METALLIC (448G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/448G Dark Metallic Turquoise.jpg"
// //             },
// //             {
// //                 "id": "85",
// //                 "parentcode": "11",
// //                 "name": "DARK AQUA METALLIC (421G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/421G Dark Metallic Aqua.jpg"
// //             },
// //             {
// //                 "id": "86",
// //                 "parentcode": "11",
// //                 "name": "RED CRIMSON (510)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/510 Red Crimson.jpg"
// //             },
// //             {
// //                 "id": "87",
// //                 "parentcode": "11",
// //                 "name": "RED (501G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/501G Red.jpg"
// //             },
// //             {
// //                 "id": "88",
// //                 "parentcode": "11",
// //                 "name": "RED (503A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/503A Red.jpg"
// //             },
// //             {
// //                 "id": "89",
// //                 "parentcode": "11",
// //                 "name": "RED (505)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/505 Red.jpg"
// //             },
// //             {
// //                 "id": "90",
// //                 "parentcode": "11",
// //                 "name": "RED (507)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/507 Red.jpg"
// //             },
// //             {
// //                 "id": "91",
// //                 "parentcode": "11",
// //                 "name": "RED (548/508G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/508G Red.jpg"
// //             },
// //             {
// //                 "id": "92",
// //                 "parentcode": "11",
// //                 "name": "RED (511G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/511G Red.jpg"
// //             },
// //             {
// //                 "id": "93",
// //                 "parentcode": "11",
// //                 "name": "RED (513G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/513G Red.jpg"
// //             },
// //             {
// //                 "id": "94",
// //                 "parentcode": "11",
// //                 "name": "RED (514G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/514G Red.jpg"
// //             },
// //             {
// //                 "id": "95",
// //                 "parentcode": "11",
// //                 "name": "RED (528/528G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/528 Red.jpg"
// //             },
// //             {
// //                 "id": "96",
// //                 "parentcode": "11",
// //                 "name": "RED (535G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/535G Red.jpg"
// //             },
// //             {
// //                 "id": "97",
// //                 "parentcode": "11",
// //                 "name": "RED (550)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/550 Red.jpg"
// //             },
// //             {
// //                 "id": "98",
// //                 "parentcode": "11",
// //                 "name": "DARK RED (502G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/502G Dark Red.jpg"
// //             },
// //             {
// //                 "id": "99",
// //                 "parentcode": "11",
// //                 "name": "DARK RED (503G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/503G Dark Red.jpg"
// //             },
// //             {
// //                 "id": "100",
// //                 "parentcode": "11",
// //                 "name": "DARK RED (504)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/504 Dark Red.jpg"
// //             },
// //             {
// //                 "id": "101",
// //                 "parentcode": "11",
// //                 "name": "DARK RED (508)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/508 Dark Red.jpg"
// //             },
// //             {
// //                 "id": "102",
// //                 "parentcode": "11",
// //                 "name": "DARK RED (512A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/512A Dark Red.jpg"
// //             },
// //             {
// //                 "id": "103",
// //                 "parentcode": "11",
// //                 "name": "DARK RED (535A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/535A Dark Red.jpg"
// //             },
// //             {
// //                 "id": "104",
// //                 "parentcode": "11",
// //                 "name": "RED METALLIC (520)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/520 Red Metallic.jpg"
// //             },
// //             {
// //                 "id": "105",
// //                 "parentcode": "11",
// //                 "name": "RED METALLIC (520G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/520G Metallic Red.jpg"
// //             },
// //             {
// //                 "id": "106",
// //                 "parentcode": "11",
// //                 "name": "BRIGHT RED (510G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/510G Bright Red.jpg"
// //             },
// //             {
// //                 "id": "107",
// //                 "parentcode": "11",
// //                 "name": "CARMINE RED (504G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/504G Carmine.jpg"
// //             },
// //             {
// //                 "id": "108",
// //                 "parentcode": "11",
// //                 "name": "MAROON METALLIC (526)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/526 Maroon Metallic.jpg"
// //             },
// //             {
// //                 "id": "109",
// //                 "parentcode": "11",
// //                 "name": "BURGUNDY (525G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/525G Burgundy.jpg"
// //             },
// //             {
// //                 "id": "110",
// //                 "parentcode": "11",
// //                 "name": "BRONZE METALLIC (640)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/640 Bronze.jpg"
// //             },
// //             {
// //                 "id": "111",
// //                 "parentcode": "11",
// //                 "name": "DK BRONZE METALLIC (634/631G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/631G Bronze Gold.jpg"
// //             },
// //             {
// //                 "id": "112",
// //                 "parentcode": "11",
// //                 "name": "SADDLE METALLIC (654/625G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/625G Saddle Bronze.jpg"
// //             },
// //             {
// //                 "id": "113",
// //                 "parentcode": "11",
// //                 "name": "BURNISHED SADDLE (658G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/658G Burnished Saddle.jpg"
// //             },
// //             {
// //                 "id": "114",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (640A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/640A Saddle.jpg"
// //             },
// //             {
// //                 "id": "115",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (650)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/650 Saddle.jpg"
// //             },
// //             {
// //                 "id": "116",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (672G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/672G Saddle.jpg"
// //             },
// //             {
// //                 "id": "117",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (678G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/678G Saddle.jpg"
// //             },
// //             {
// //                 "id": "118",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (679G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/679G Saddle.jpg"
// //             },
// //             {
// //                 "id": "119",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (683G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/683G Saddle.jpg"
// //             },
// //             {
// //                 "id": "120",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (685G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/685G Saddle.jpg"
// //             },
// //             {
// //                 "id": "121",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (687G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/687G Saddle.jpg"
// //             },
// //             {
// //                 "id": "122",
// //                 "parentcode": "11",
// //                 "name": "SADDLE (690G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/690G Saddle.jpg"
// //             },
// //             {
// //                 "id": "123",
// //                 "parentcode": "11",
// //                 "name": "BROWN (647A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/647A Brown.jpg"
// //             },
// //             {
// //                 "id": "124",
// //                 "parentcode": "11",
// //                 "name": "BROWN (656/656A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/656 Brown.jpg"
// //             },
// //             {
// //                 "id": "125",
// //                 "parentcode": "11",
// //                 "name": "BROWN (656G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/656G Brown.jpg"
// //             },
// //             {
// //                 "id": "126",
// //                 "parentcode": "11",
// //                 "name": "BROWN (662)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/662 Brown.jpg"
// //             },
// //             {
// //                 "id": "127",
// //                 "parentcode": "11",
// //                 "name": "BROWN (664)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/664 Brown.jpg"
// //             },
// //             {
// //                 "id": "128",
// //                 "parentcode": "11",
// //                 "name": "CHESTNUT (600)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/600 Chestnut.jpg"
// //             },
// //             {
// //                 "id": "129",
// //                 "parentcode": "11",
// //                 "name": "GINGER (616)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/616 Ginger.jpg"
// //             },
// //             {
// //                 "id": "130",
// //                 "parentcode": "11",
// //                 "name": "BUCKSKIN (684G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/684G Buckskin.jpg"
// //             },
// //             {
// //                 "id": "131",
// //                 "parentcode": "11",
// //                 "name": "BUCKSKIN (709G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/709G Buckskin.jpg"
// //             },
// //             {
// //                 "id": "132",
// //                 "parentcode": "11",
// //                 "name": "BUCKSKIN (710G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/710G Buckskin.jpg"
// //             },
// //             {
// //                 "id": "133",
// //                 "parentcode": "11",
// //                 "name": "TAUPE (206)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/206 Taupe.jpg"
// //             },
// //             {
// //                 "id": "134",
// //                 "parentcode": "11",
// //                 "name": "TAUPE (209)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/209 Taupe.jpg"
// //             },
// //             {
// //                 "id": "135",
// //                 "parentcode": "11",
// //                 "name": "TAN (649)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/649 Tan.jpg"
// //             },
// //             {
// //                 "id": "136",
// //                 "parentcode": "11",
// //                 "name": "TAN (668/668A)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/668 Tan.jpg"
// //             },
// //             {
// //                 "id": "137",
// //                 "parentcode": "11",
// //                 "name": "TAN (670)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/670 Tan.jpg"
// //             },
// //             {
// //                 "id": "138",
// //                 "parentcode": "11",
// //                 "name": "TAN (670G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/670G Tan.jpg"
// //             },
// //             {
// //                 "id": "139",
// //                 "parentcode": "11",
// //                 "name": "CAMEL TAN (671G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/671G Camel Tan.jpg"
// //             },
// //             {
// //                 "id": "140",
// //                 "parentcode": "11",
// //                 "name": "CAMEL TAN (688G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/688G Camel Tan.jpg"
// //             },
// //             {
// //                 "id": "141",
// //                 "parentcode": "11",
// //                 "name": "SANDALWOOD (699/694G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/694G Sandalwood.jpg"
// //             },
// //             {
// //                 "id": "142",
// //                 "parentcode": "11",
// //                 "name": "SANDALWOOD (695G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/695G Sandalwood.jpg"
// //             },
// //             {
// //                 "id": "143",
// //                 "parentcode": "11",
// //                 "name": "SANDALWOOD (697G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/697G Sandalwood.jpg"
// //             },
// //             {
// //                 "id": "144",
// //                 "parentcode": "11",
// //                 "name": "DARK SANDALWOOD (689G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/689G Dark Sandalwood.jpg"
// //             },
// //             {
// //                 "id": "145",
// //                 "parentcode": "11",
// //                 "name": "GOLD (635G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/635G Gold.jpg"
// //             },
// //             {
// //                 "id": "146",
// //                 "parentcode": "11",
// //                 "name": "GOLD METALLIC (642G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/642G Metallic Gold.jpg"
// //             },
// //             {
// //                 "id": "147",
// //                 "parentcode": "11",
// //                 "name": "GOLD METALLIC (630/650G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/630 Gold.jpg"
// //             },
// //             {
// //                 "id": "148",
// //                 "parentcode": "11",
// //                 "name": "GOLD METALLIC (651G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/651G Metallic Gold.jpg"
// //             },
// //             {
// //                 "id": "149",
// //                 "parentcode": "11",
// //                 "name": "MEDIUM FAWN METALLIC (610)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/610 Metallic Fawn.jpg"
// //             },
// //             {
// //                 "id": "150",
// //                 "parentcode": "11",
// //                 "name": "MEDIUM GOLD METALLIC (614)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/614 Gold.jpg"
// //             },
// //             {
// //                 "id": "151",
// //                 "parentcode": "11",
// //                 "name": "EMBER GOLD (636)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/636 Ember Gold.jpg"
// //             },
// //             {
// //                 "id": "152",
// //                 "parentcode": "11",
// //                 "name": "EMBER GOLD (666)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/666 Ember Gold.jpg"
// //             },
// //             {
// //                 "id": "153",
// //                 "parentcode": "11",
// //                 "name": "WILLOW GOLD (645G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/645G Willow Gold.jpg"
// //             },
// //             {
// //                 "id": "154",
// //                 "parentcode": "11",
// //                 "name": "HONEY GOLD (671)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/671 Honey Gold.jpg"
// //             },
// //             {
// //                 "id": "155",
// //                 "parentcode": "11",
// //                 "name": "COPPER METALLIC (620)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/620 Copper Metallic.jpg"
// //             },
// //             {
// //                 "id": "156",
// //                 "parentcode": "11",
// //                 "name": "DARK COPPER METALLIC (606)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/606 Dark Copper.jpg"
// //             },
// //             {
// //                 "id": "157",
// //                 "parentcode": "11",
// //                 "name": "PEARL YELLOW (644/640G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/640G Pearl Yellow.jpg"
// //             },
// //             {
// //                 "id": "158",
// //                 "parentcode": "11",
// //                 "name": "YELLOW (641G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/641G Yellow.jpg"
// //             },
// //             {
// //                 "id": "159",
// //                 "parentcode": "11",
// //                 "name": "ORANGE (500G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/500G Orange.jpg"
// //             },
// //             {
// //                 "id": "160",
// //                 "parentcode": "11",
// //                 "name": "DARK ORANGE (542)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/542 Dark Orange.jpg"
// //             },
// //             {
// //                 "id": "161",
// //                 "parentcode": "11",
// //                 "name": "BRIGHT ORANGE (560)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/560 Bright Orange.jpg"
// //             },
// //             {
// //                 "id": "162",
// //                 "parentcode": "11",
// //                 "name": "BURNT ORANGE (540)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/540 Burnt Orange.jpg"
// //             },
// //             {
// //                 "id": "163",
// //                 "parentcode": "11",
// //                 "name": "SIENNA (657G)",
// //                 "price": "90",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/657G Sienna.jpg"
// //             }
// //         ]
// //     },
// //     {
// //         "name": "GRAINS",
// //         "description": "GRAINS",
// //         "options": [
// //             {
// //                 "id": "1",
// //                 "parentcode": "12",
// //                 "name": "ASCOT",
// //                 "price": "ASCOT",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Ascot.jpg"
// //             },
// //             {
// //                 "id": "2",
// //                 "parentcode": "12",
// //                 "name": "BAMBINO",
// //                 "price": "BAMBIN",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Bambino.jpg"
// //             },
// //             {
// //                 "id": "3",
// //                 "parentcode": "12",
// //                 "name": "BASKETWEAVE (1964 CHRYSLER)",
// //                 "price": "BASKET",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/1964 Basketweave.jpg"
// //             },
// //             {
// //                 "id": "4",
// //                 "parentcode": "12",
// //                 "name": "BASKETWEAVE (1965 CHRYSLER)",
// //                 "price": "BASKET",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Chrysler Basketweave.jpg"
// //             },
// //             {
// //                 "id": "5",
// //                 "parentcode": "12",
// //                 "name": "BASKETWEAVE (AMC)",
// //                 "price": "BASKET",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/AMC Basketweave.jpg"
// //             },
// //             {
// //                 "id": "6",
// //                 "parentcode": "12",
// //                 "name": "BASKETWEAVE (GM)",
// //                 "price": "BASKET",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Basketweave.jpg"
// //             },
// //             {
// //                 "id": "7",
// //                 "parentcode": "12",
// //                 "name": "BEDFORD",
// //                 "price": "BEDFOR",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Bedford.jpg"
// //             },
// //             {
// //                 "id": "8",
// //                 "parentcode": "12",
// //                 "name": "BELMONT",
// //                 "price": "BELMON",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Belmont.jpg"
// //             },
// //             {
// //                 "id": "9",
// //                 "parentcode": "12",
// //                 "name": "BISON",
// //                 "price": "BISON",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Bison.jpg"
// //             },
// //             {
// //                 "id": "10",
// //                 "parentcode": "12",
// //                 "name": "BOAR",
// //                 "price": "BOAR",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Boar.jpg"
// //             },
// //             {
// //                 "id": "11",
// //                 "parentcode": "12",
// //                 "name": "CIRRUS",
// //                 "price": "CIRRUS",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Cirrus.jpg"
// //             },
// //             {
// //                 "id": "12",
// //                 "parentcode": "12",
// //                 "name": "COACHMAN",
// //                 "price": "COACHM",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Coachman.jpg"
// //             },
// //             {
// //                 "id": "13",
// //                 "parentcode": "12",
// //                 "name": "COLOGNE",
// //                 "price": "COLOGN",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Cologne.jpg"
// //             },
// //             {
// //                 "id": "14",
// //                 "parentcode": "12",
// //                 "name": "COMFORTWEAVE",
// //                 "price": "WEAVE",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Comfortweave.jpg"
// //             },
// //             {
// //                 "id": "15",
// //                 "parentcode": "12",
// //                 "name": "CRATER",
// //                 "price": "CRATER",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Crater.jpg"
// //             },
// //             {
// //                 "id": "16",
// //                 "parentcode": "12",
// //                 "name": "CRUSH",
// //                 "price": "CRUSH",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Crush.jpg"
// //             },
// //             {
// //                 "id": "17",
// //                 "parentcode": "12",
// //                 "name": "CRUSHED ICE",
// //                 "price": "CRUSHE",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Crushed Ice.jpg"
// //             },
// //             {
// //                 "id": "18",
// //                 "parentcode": "12",
// //                 "name": "DAKOTA",
// //                 "price": "DAKOTA",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Dakota.jpg"
// //             },
// //             {
// //                 "id": "19",
// //                 "parentcode": "12",
// //                 "name": "DERMA",
// //                 "price": "DERMA",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Derma.jpg"
// //             },
// //             {
// //                 "id": "20",
// //                 "parentcode": "12",
// //                 "name": "DIAMOND BASKETWEAVE",
// //                 "price": "DIAMON",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Diamond Basketweave.jpg"
// //             },
// //             {
// //                 "id": "21",
// //                 "parentcode": "12",
// //                 "name": "DIAMOND WAFFLE",
// //                 "price": "DIAMON",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Diamond Waffle.jpg"
// //             },
// //             {
// //                 "id": "22",
// //                 "parentcode": "12",
// //                 "name": "DOESKIN",
// //                 "price": "DOESKI",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Doeskin.jpg"
// //             },
// //             {
// //                 "id": "23",
// //                 "parentcode": "12",
// //                 "name": "DORCHESTER",
// //                 "price": "DORCHE",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Dorchester.jpg"
// //             },
// //             {
// //                 "id": "24",
// //                 "parentcode": "12",
// //                 "name": "DOUBLE DIAMOND",
// //                 "price": "DOUBLE",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Double Diamond.jpg"
// //             },
// //             {
// //                 "id": "25",
// //                 "parentcode": "12",
// //                 "name": "DOUBLE STITCH RIB",
// //                 "price": "DOUBLE",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Double Stitch Rib.jpg"
// //             },
// //             {
// //                 "id": "26",
// //                 "parentcode": "12",
// //                 "name": "EL PASO",
// //                 "price": "EL PAS",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/El Paso.jpg"
// //             },
// //             {
// //                 "id": "27",
// //                 "parentcode": "12",
// //                 "name": "ELK",
// //                 "price": "GM ELK",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Elk.jpg"
// //             },
// //             {
// //                 "id": "28",
// //                 "parentcode": "12",
// //                 "name": "EMPIRE",
// //                 "price": "EMPIRE",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Empire.jpg"
// //             },
// //             {
// //                 "id": "29",
// //                 "parentcode": "12",
// //                 "name": "KNITTED",
// //                 "price": "KNITTE",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Knitted.jpg"
// //             },
// //             {
// //                 "id": "30",
// //                 "parentcode": "12",
// //                 "name": "KRINKLE",
// //                 "price": "KRINKL",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Krinkle.jpg"
// //             },
// //             {
// //                 "id": "31",
// //                 "parentcode": "12",
// //                 "name": "KV",
// //                 "price": "KV",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/KV.jpg"
// //             },
// //             {
// //                 "id": "32",
// //                 "parentcode": "12",
// //                 "name": "LAREDO",
// //                 "price": "LAREDO",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Laredo.jpg"
// //             },
// //             {
// //                 "id": "33",
// //                 "parentcode": "12",
// //                 "name": "MADRID",
// //                 "price": "MADRID",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Madrid.jpg"
// //             },
// //             {
// //                 "id": "34",
// //                 "parentcode": "12",
// //                 "name": "OSTRICH",
// //                 "price": "OSTRIC",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Ostrich.jpg"
// //             },
// //             {
// //                 "id": "35",
// //                 "parentcode": "12",
// //                 "name": "OXEN",
// //                 "price": "OXEN",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Oxen.jpg"
// //             },
// //             {
// //                 "id": "36",
// //                 "parentcode": "12",
// //                 "name": "OXFORD",
// //                 "price": "OXFORD",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Oxford.jpg"
// //             },
// //             {
// //                 "id": "37",
// //                 "parentcode": "12",
// //                 "name": "PEMBROOK",
// //                 "price": "PEMBRO",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Pembrook.jpg"
// //             },
// //             {
// //                 "id": "38",
// //                 "parentcode": "12",
// //                 "name": "PIGSKIN",
// //                 "price": "PIGSKI",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Pigskin.jpg"
// //             },
// //             {
// //                 "id": "39",
// //                 "parentcode": "12",
// //                 "name": "PINPOINT",
// //                 "price": "PINPOI",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Pinpoint.jpg"
// //             },
// //             {
// //                 "id": "41",
// //                 "parentcode": "12",
// //                 "name": "RANGER",
// //                 "price": "RANGER",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Ranger.jpg"
// //             },
// //             {
// //                 "id": "43",
// //                 "parentcode": "12",
// //                 "name": "REED",
// //                 "price": "REED",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Reed.jpg"
// //             },
// //             {
// //                 "id": "44",
// //                 "parentcode": "12",
// //                 "name": "REGAL",
// //                 "price": "REGAL",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Regal.jpg"
// //             },
// //             {
// //                 "id": "45",
// //                 "parentcode": "12",
// //                 "name": "RICHMOND",
// //                 "price": "RICHMO",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Richmond.jpg"
// //             },
// //             {
// //                 "id": "46",
// //                 "parentcode": "12",
// //                 "name": "ROSETTE",
// //                 "price": "ROSETT",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Rosette.jpg"
// //             },
// //             {
// //                 "id": "47",
// //                 "parentcode": "12",
// //                 "name": "ROULET",
// //                 "price": "ROULET",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Roulet.jpg"
// //             },
// //             {
// //                 "id": "48",
// //                 "parentcode": "12",
// //                 "name": "SEVILLE 'A'",
// //                 "price": "SEVILL",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Seville A.jpg"
// //             },
// //             {
// //                 "id": "49",
// //                 "parentcode": "12",
// //                 "name": "SEVILLE 'B'",
// //                 "price": "SEVILL",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Seville B.jpg"
// //             },
// //             {
// //                 "id": "50",
// //                 "parentcode": "12",
// //                 "name": "SHALLOW ELK",
// //                 "price": "SHALLO",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Shallow Elk.jpg"
// //             },
// //             {
// //                 "id": "51",
// //                 "parentcode": "12",
// //                 "name": "SIERRA",
// //                 "price": "SIERRA",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Sierra.jpg"
// //             },
// //             {
// //                 "id": "52",
// //                 "parentcode": "12",
// //                 "name": "STAR",
// //                 "price": "STAR",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Star.jpg"
// //             },
// //             {
// //                 "id": "53",
// //                 "parentcode": "12",
// //                 "name": "TETRA",
// //                 "price": "TETRA",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Tetra.jpg"
// //             },
// //             {
// //                 "id": "54",
// //                 "parentcode": "12",
// //                 "name": "UGANDA",
// //                 "price": "UGANDA",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Uganda.jpg"
// //             },
// //             {
// //                 "id": "55",
// //                 "parentcode": "12",
// //                 "name": "VENTILAIR",
// //                 "price": "VENTIL",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Ventilair.jpg"
// //             },
// //             {
// //                 "id": "56",
// //                 "parentcode": "12",
// //                 "name": "VEXON",
// //                 "price": "VEXON",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Vexon.jpg"
// //             },
// //             {
// //                 "id": "58",
// //                 "parentcode": "12",
// //                 "name": "WALRUS",
// //                 "price": "WALRUS",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Walrus.jpg"
// //             },
// //             {
// //                 "id": "59",
// //                 "parentcode": "12",
// //                 "name": "1/16 RIB",
// //                 "price": "1/16 R",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/One Sixteenth Rib.jpg"
// //             },
// //             {
// //                 "id": "60",
// //                 "parentcode": "12",
// //                 "name": "1/4 RIB",
// //                 "price": "1/4 RI",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/One Quarter Rib.jpg"
// //             },
// //             {
// //                 "id": "61",
// //                 "parentcode": "12",
// //                 "name": "3/5 RIB",
// //                 "price": "3/5 RI",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/Three Fifth Rib.jpg"
// //             }
// //         ]
// //     },
// //     {
// //         "name": "LEATHER_COLORS",
// //         "description": "LEATHER COLORS",
// //         "options": [
// //             {
// //                 "id": "1",
// //                 "parentcode": "13",
// //                 "name": "BLACK (100)",
// //                 "price": "485",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/100 Black.jpg"
// //             },
// //             {
// //                 "id": "2",
// //                 "parentcode": "13",
// //                 "name": "GUNMETAL (140)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/140 Gunmetal.jpg"
// //             },
// //             {
// //                 "id": "3",
// //                 "parentcode": "13",
// //                 "name": "CHARCOAL (154)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/154 Charcoal.jpg"
// //             },
// //             {
// //                 "id": "4",
// //                 "parentcode": "13",
// //                 "name": "DARK CHARCOAL (110A)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/110A Charcoal.jpg"
// //             },
// //             {
// //                 "id": "5",
// //                 "parentcode": "13",
// //                 "name": "SILVER (102G)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/102G Silver.jpg"
// //             },
// //             {
// //                 "id": "6",
// //                 "parentcode": "13",
// //                 "name": "WHITE (200)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/200 White.jpg"
// //             },
// //             {
// //                 "id": "7",
// //                 "parentcode": "13",
// //                 "name": "PEARL WHITE (202)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/202 Pearl White.jpg"
// //             },
// //             {
// //                 "id": "8",
// //                 "parentcode": "13",
// //                 "name": "DARK BLUE (330)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/330 Dark Blue Metallic.jpg"
// //             },
// //             {
// //                 "id": "9",
// //                 "parentcode": "13",
// //                 "name": "BRIGHT BLUE (338)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/338 Bright Blue.jpg"
// //             },
// //             {
// //                 "id": "10",
// //                 "parentcode": "13",
// //                 "name": "DARK GREEN (434)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/434 Dark Green Metallic.jpg"
// //             },
// //             {
// //                 "id": "11",
// //                 "parentcode": "13",
// //                 "name": "DARK RED (512A)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/512A Dark Red.jpg"
// //             },
// //             {
// //                 "id": "12",
// //                 "parentcode": "13",
// //                 "name": "RED METALLIC (520)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/520 Red Metallic.jpg"
// //             },
// //             {
// //                 "id": "13",
// //                 "parentcode": "13",
// //                 "name": "BURNT ORANGE (540)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/540 Burnt Orange.jpg"
// //             },
// //             {
// //                 "id": "14",
// //                 "parentcode": "13",
// //                 "name": "SADDLE (640A)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/640A Saddle.jpg"
// //             },
// //             {
// //                 "id": "15",
// //                 "parentcode": "13",
// //                 "name": "SADDLE (650)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/650 Saddle.jpg"
// //             },
// //             {
// //                 "id": "16",
// //                 "parentcode": "13",
// //                 "name": "BROWN (655A)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/655A Brown.jpg"
// //             },
// //             {
// //                 "id": "17",
// //                 "parentcode": "13",
// //                 "name": "BROWN (656)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/656 Brown.jpg"
// //             },
// //             {
// //                 "id": "18",
// //                 "parentcode": "13",
// //                 "name": "DARK BROWN (664)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/664 Brown.jpg"
// //             },
// //             {
// //                 "id": "19",
// //                 "parentcode": "13",
// //                 "name": "EMBER GOLD (666)",
// //                 "price": "975",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/666 Ember Gold.jpg"
// //             }
// //         ]
// //     },
// //     {
// //         "name": "CLOTH_COLORS",
// //         "description": "CLOTH COLORS",
// //         "options": [
// //             {
// //                 "id": "1",
// //                 "parentcode": "14",
// //                 "name": "BLACK/WHITE SALT/PEPPER (810)",
// //                 "price": "250",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/810 Salt and Pepper Cloth Black and White.jpg"
// //             },
// //             {
// //                 "id": "2",
// //                 "parentcode": "14",
// //                 "name": "BLACK/WHITE PLAID (830)",
// //                 "price": "250",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/830 Plaid Cloth Black and White.jpg"
// //             },
// //             {
// //                 "id": "3",
// //                 "parentcode": "14",
// //                 "name": "BLACK/WHITE HOUNDSTOOTH (831G)",
// //                 "price": "250",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/831G Black and White Houndstooth Cloth.jpg"
// //             },
// //             {
// //                 "id": "4",
// //                 "parentcode": "14",
// //                 "name": "BLACK/WHITE HOUNDSTOOTH (824G)",
// //                 "price": "250",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/824G Black and White Houndstooth Cloth.jpg"
// //             },
// //             {
// //                 "id": "5",
// //                 "parentcode": "14",
// //                 "name": "BLK/ORANGE HOUNDSTOOTH (825G)",
// //                 "price": "250",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/825G Black and Orange Houndstooth Cloth.jpg"
// //             },
// //             {
// //                 "id": "6",
// //                 "parentcode": "14",
// //                 "name": "BLK/YELLOW HOUNDSTOOTH (826G)",
// //                 "price": "250",
// //                 "image": "https://www.legendaryautointeriors.com/wp-content/plugins/ws-design-center/CDC-images/826G Black and Yellow Houndstooth Cloth.jpg"
// //             }
// //         ]
// //     }
// // ]